import axios from '../../services/axios'
import { setMessage } from './message';
import * as actionTypes from './actionTypes';

export const loadAcademicDepartments = () => {
    return {
        type: actionTypes.LOAD_ACADEMIC_DEPARTMENTS
    }
}

export const setAcademicDepartments = (academicDepartments) => {
    return {
        type: actionTypes.SET_ACADEMIC_DEPARTMENTS,
        academicDepartments: academicDepartments
    }
}

export const getAcademicDepartments = () => {
    return (dispatch) => {
        dispatch(loadAcademicDepartments())
        axios.get( `/api/v1/departments` )
            .then( response => {
                dispatch( setAcademicDepartments(response.data))
            } )
            .catch( error => {
                dispatch( setAcademicDepartments([]))
                dispatch( setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

export const loadDepartmentAnnouncements = () => {
    return {
        type: actionTypes.LOAD_DEPARTMENT_ANNOUNCEMENTS
    }
}

export const setDepartmentAnnouncements = (departmentAnnouncements) => {
    return {
        type: actionTypes.SET_DEPARTMENT_ANNOUNCEMENTS,
        departmentAnnouncements: departmentAnnouncements
    }
}

export const getDepartmentAnnouncements = (departmentId) => {
    return (dispatch) => {
        dispatch(loadDepartmentAnnouncements())
        axios.get( `/api/v1/announcements/departments?id=${departmentId}` )
            .then( response => {
                dispatch( setDepartmentAnnouncements(response.data))
            } )
            .catch( error => {
                dispatch( setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

export const loadDepartmentSchedule = () => {
    return {
        type: actionTypes.LOAD_DEPARTMENT_SCHEDULE
    }
}

export const onLoadDepartmentScheduleStopped = () => {
    return {
        type: actionTypes.SAVE_DEPARTMENT_SCHEDULE
    }
}

export const saveDepartmentSchedule = (response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    let filename = response.headers['file-name'];
    if (!filename || filename.length === 0) {
        filename = 'Расписание кафедры.xlsx';
    } else {
        filename = decodeURI(filename);
    }
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    return onLoadDepartmentScheduleStopped();
}

export const downloadDepartmentSchedule = (departmentId) => {
    return (dispatch) => {
        dispatch(loadDepartmentSchedule())
        axios.get( `/api/v1/departments/report?department-id=${departmentId}`,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/vnd.ms-excel'
                }
            }
        ).then( response => {
            dispatch( saveDepartmentSchedule(response))
        } ).catch( error => {
            dispatch( setMessage({type: 'error', text: "Не удалось скачать файл."}))
            dispatch(onLoadDepartmentScheduleStopped())
        } );
    }
}